<template>
  <div class="bullets">
    <div
      class="bullet"
      :key="`bullet_${idx}`"
      :class="
          step === idx
            ? bullet.correct === null ? 'fill' : bullet.correct ? 'correct' : 'failed'
            : bullet.correct === null ? '' : bullet.correct ? 'correct' : 'failed'
      "
      v-for="(bullet, idx) in bullets"
    >
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      hint: { type: Boolean, default: false },
      bullets: { type: Array }
    },
    computed: {
      step () {
        return this.$store.state.current
      }
    }
  }
</script>

<style lang="scss">
  .bullets {
    display: inline-flex;
    align-items: center;
  }

  .bullet {
    display: inline-block;
    width: 1em;
    height: 1em;
    font-size: 10px;
    border-radius: 50%;
    background: currentColor;
    transition: 0.25s box-shadow;
    box-shadow: 0 0 7px currentColor;
    color: $color-cyan;
    margin: 0 5px;

    &.correct {
      color: $color-green
    }

    &.failed {
      color: $color-red
    }

    &.fill {
      color: #fff
    }
  }
</style>
